import React, { FC } from 'react'
import { TopicStat } from '../../../models/topics/stat'
import Typography from '../typography'

type Props = {
  keyStatsData: any
  isCustomerStory: boolean
}

export const Stats: FC<Props> = ({ keyStatsData, isCustomerStory }) => (
  <div className="KeyStats__Inner-Container">
    {keyStatsData?.stats?.length > 0 &&
      keyStatsData.stats.map((item: TopicStat, index: number) => (
        <div className="KeyStats__Item" key={index}>
          <div className="upper__item">
            {item?.upperText && (
              <Typography type="header6" className="KeyStats__UpperText">
                {item?.upperText}
              </Typography>
            )}

            {item?.number && (
              <Typography
                type={isCustomerStory ? 'header3' : 'header2'}
                className="KeyStats__Number">
                {item?.number}
              </Typography>
            )}

            {item?.text && (
              <Typography type={isCustomerStory ? 'bodyXS' : 'header6'} className="KeyStats__Text">
                {item?.text}
              </Typography>
            )}
          </div>
          {item?.source && (
            <div className="bottom">
              <Typography type={isCustomerStory ? 'bodyXS' : 'body'} className="KeyStats__Source">
                {item?.source}
              </Typography>
            </div>
          )}
        </div>
      ))}
  </div>
)

const EventsKeyStat = (data: any) => {
  return (
    <div className="KeyStats__Item">
      <div className="upper__item">
        {data?.number && (
          <Typography type={'header2'} className="KeyStats__Number">
            {data?.number}
          </Typography>
        )}

        {data?.text && (
          <Typography type={'header6'} className="KeyStats__Text">
            {data?.text}
          </Typography>
        )}
      </div>
    </div>
  )
}

export const FeaturedEventStats: FC<Props> = ({ keyStatsData }) => {
  return (
    <div className="KeyStats__Inner-Container-Events">
      <div className="KeyStats__Container">
        <div className="KeyStats__Left">
          {EventsKeyStat(keyStatsData.stats[0])}
          {keyStatsData.stats[2] ? EventsKeyStat(keyStatsData.stats[2]) : ''}
        </div>
        <div className="KeyStats__Right">
          {keyStatsData.stats[1] ? EventsKeyStat(keyStatsData.stats[1]) : ''}
          {keyStatsData.stats[3] ? EventsKeyStat(keyStatsData.stats[3]) : ''}
        </div>
      </div>

      <div className="KeyStats__Featurd-Image">
        {keyStatsData.eventImage && (
          <img src={keyStatsData.eventImage.image.file.url} alt="eventImage" />
        )}
      </div>
    </div>
  )
}
